var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fullpage-hint", attrs: { id: "fullpage_hint" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "fullpage-hint__dialog", persistent: true },
          model: {
            value: _vm.notification_dialog,
            callback: function($$v) {
              _vm.notification_dialog = $$v
            },
            expression: "notification_dialog"
          }
        },
        [
          _c("div", { staticClass: "fullpage-hint__container" }, [
            _c(
              "div",
              { staticClass: "fullpage-hint__wrapper" },
              [
                _c("v-icon", { attrs: { color: "#ee3934", large: "" } }, [
                  _vm._v(
                    "\n                    icon-report-problem\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "fullpage-hint__text-container" }, [
                  _c("span", { staticClass: "fullpage-hint__title" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.title) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "fullpage-hint__content" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.content) +
                        "\n                    "
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.is_show_confirm_btn
              ? _c(
                  "div",
                  { staticClass: "fullpage-hint__wrapper" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "fullpage-hint__btn",
                        on: { click: _vm.close_notification_dialog }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("__fullpage_hint.understood")) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }